<template>
  <div id="app">
    <!-- <keep-alive include='home'>
      <router-view></router-view>
    </keep-alive> -->
  <keep-alive include='home'>
    <router-view v-if="$route.meta.keepAlive || isReloadAlive && $route.meta.flag"></router-view>
  </keep-alive>
  <router-view v-if="!$route.meta.keepAlive && !$route.meta.flag"></router-view>
  </div>
</template>

<script>
    export default {
        name: 'App',
         provide() {
         return {
             reload: this.reload
         }
    },
        data:function(){
            return{
              isReloadAlive : true  
            }
        },
        methods: {
          reload() {
          this.isReloadAlive = false;
          this.$nextTick(function(){
            this.isReloadAlive = true;
          })
		},
        },

        created(){
           console.log("135153",this.$route.meta.keepAlive)
        }
    }
</script>
<style>
*{
  margin: 0;
  padding: 0;
}
html,body{
  width: 100%;
}
#app{
  width: 100%;
  overflow: hidden;
}
.daohang{
  width: 100%;
  height: 0.6rem;
  background-color: red;
}
</style>
